import { get, head } from 'lodash-es'
import { constantCase } from 'change-case'

import { getRelatedIncludes } from '@/js/helper/relationships-helper'
import API_CONSTANTS from '@/js/helper/api-constants'

export const getItemName = ({ item, included }) => {
  const typeConstant = constantCase(get(item, API_CONSTANTS.TYPE))
  const texts = getRelatedIncludes({
    relationships: get(item, API_CONSTANTS.RELATIONSHIPS, {}),
    included,
    type: API_CONSTANTS.AIMEOS.TYPE.TEXT,
  })
  const nameItem = head(
    texts.filter(
      text =>
        get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE) === API_CONSTANTS.AIMEOS.TEXT.TYPE.NAME,
    ),
  )
  const name = nameItem ? get(nameItem, API_CONSTANTS.AIMEOS.TEXT.PATHS.CONTENT) : undefined
  return name || get(item, API_CONSTANTS.AIMEOS[typeConstant].PATHS.LABEL)
}

export const getTextByType = ({ type, texts = [] } = {}) =>
  texts.filter(text => get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE) === type)

export const getTextByTypeRegex = ({ regex, texts = [] } = {}) => {
  return texts.filter(text => regex.test(get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE)))
}

export const sortTextByType = ({ texts = [], direction = 1 }) =>
  texts.sort((a, b) => {
    const typeA = get(a, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE)
    const typeB = get(b, API_CONSTANTS.AIMEOS.TEXT.PATHS.TYPE)
    return typeA < typeB ? direction * -1 : typeA > typeB ? direction * 1 : 0
  })

export const getTextContent = text =>
  text ? get(text, API_CONSTANTS.AIMEOS.TEXT.PATHS.CONTENT) : undefined
